import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Anchor from '../../../../../../dashboardNew/objects/Anchor';

class CourseSlider extends Component {

    render() {

        const modules = this.props.modules[0].modules;
        const courseTitle = this.props.courseTitle;
        const activeTrailer = (!this.props.current.name || this.props.current.name === courseTitle.name) ? 'active' : ''
        const currentWorksheet = this.props.current.worksheet_url ? this.props.current.worksheet_url : null
        const currentModule = this.props.current.name && this.props.current.name.split(':')[0]
        return (
            <div className="col-12 col-lg-4 courses-sidebar">
                <div className='modules-heading'>
                    <h2 className="heading-two ">Modules</h2>
                    {currentWorksheet && <Anchor path={currentWorksheet} anchorClass={'pdf-button'} target>
                        <img className="pdf-image" src="/images/icons-new/contract.svg"/>
                        {currentModule} Worksheet
                    </Anchor>}
                </div>
                <ul className="video-module-list">
                    <li className="video-module-item">
                        <button
                            className={`module-link trailer ${activeTrailer}`}
                            onClick={() => this.props.updateModule(courseTitle)}
                        >
                            <span className="text">
                                Course Trailer
                            </span>
                        </button>
                    </li>
                    {
                        modules.map((mod, index) => {
                            let active = this.props.current.name === mod.name ? 'active' : ''
                            return (
                                <li className="video-module-item" key={index}>
                                    <button className={`module-link ${active}`}
                                            onClick={() => this.props.updateModule(mod)}>
                                        <span className="text">
                                            {mod.name}
                                        </span>
                                    </button>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        );
    }
}

CourseSlider.propTypes = {
    permissions: PropTypes.object,
    modules: PropTypes.array.isRequired,
    params: PropTypes.object.isRequired,
};

export default CourseSlider;


// WEBPACK FOOTER //
// src/client/components/site/features/training/courses/pages/elements/CourseSlider.js